var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04747 3.29271C9.07741 3.20057 9.20775 3.20057 9.23768 3.29271L10.4672 7.0768C10.4806 7.118 10.519 7.1459 10.5623 7.1459H14.5411C14.638 7.1459 14.6783 7.26986 14.5999 7.3268L11.381 9.6655C11.3459 9.69096 11.3313 9.7361 11.3447 9.7773L12.5742 13.5614C12.6041 13.6535 12.4987 13.7301 12.4203 13.6732L9.20136 11.3345C9.16631 11.309 9.11885 11.309 9.0838 11.3345L5.86486 13.6732C5.78649 13.7301 5.68104 13.6535 5.71097 13.5614L6.9405 9.7773C6.95389 9.7361 6.93922 9.69096 6.90417 9.6655L3.68523 7.3268C3.60686 7.26986 3.64714 7.1459 3.74401 7.1459H7.72284C7.76616 7.1459 7.80456 7.118 7.81795 7.0768L9.04747 3.29271Z",
    fill: "#EAB222",
    stroke: "#EAB222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e6bb95832d659519f1e94147682a365c.svg";
export { ForwardRef as ReactComponent };